import React from 'react';

interface CustomInputProps {
    id: string;
    label: string;
    type: string;
    value: string;
    onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
    placeholder: string;
    maxLength: number;
    required: boolean;
    autoComplete?: string;
    dataLpIgnore?: boolean;
    dataFormType?: string;
    readonly?: boolean;
}


export const CustomInput: React.FC<CustomInputProps> = ({ id, label, type, value, onChange, placeholder, maxLength, required, autoComplete = "off", dataLpIgnore = true, dataFormType = "other", readonly }) => {
    return (
        <div className="form-group">
            <label htmlFor={id}>{label}</label>
            <input
                type={type}
                id={id}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                maxLength={maxLength}
                required={required}
                autoComplete={autoComplete}
                data-lpignore={dataLpIgnore}
                data-form-type={dataFormType}
                readOnly={readonly}
            />
        </div>
    );
};
